import PropTypes from "prop-types"
import classnames from "classnames"

import SharedMarkdown from "shared/components/shared_markdown"

import styles from "./selected_service_view.module.scss"

const StepList = ({ stepType, steps }) => {
  return steps[stepType].length ? (
    <ul>
      {steps[stepType].map((step, index) => {
        return (
          <li key={index}>
            <div className={styles.title}>{step.name}</div>
            <div className={styles.description}>
              <SharedMarkdown source={step.description} />
            </div>
          </li>
        )
      })}
    </ul>
  ) : (
    <p className={styles.note}>There are no {stepType} for this service</p>
  )
}

StepList.propTypes = {
  stepType: PropTypes.oneOf(["triggers", "actions", "queries"]).isRequired,
  steps: PropTypes.object.isRequired,
}

export default StepList
